import { PartialSKU } from 'domains/skuDomain';
import './index.less';
import { IndividualSizes } from './IndividualSizes';

import { Step7JobOptions } from '../SingleWizardStep/Step7JobOptions';
import { Step8AdditionalJobOptions } from '../SingleWizardStep/Step8AdditionalJobOptions';
import { Step1InitialOverviewSection } from './Step1InitialOverviewSection';
import { Step3Quantities } from './Step3Quantities';

type Props = {
  step: number;
  sku: PartialSKU;
};

const MultiWizardStep = ({ step, sku }: Props) => {
  const steps = [
    <Step1InitialOverviewSection sku={sku} />,
    <IndividualSizes sku={sku} />,
    <Step7JobOptions sku={sku} />,
    <Step8AdditionalJobOptions sku={sku} />,
    <Step3Quantities sku={sku} />,
    // <Step4Sizes sku={sku} />,
  ];

  return <div className="multi-sku-config-wizard-step">{steps[step]}</div>;
};

export default MultiWizardStep;
